import { css } from 'linaria';

export const layoutStyles = css`
  @media (--to-desktop) {
    width: 100%;
    max-width: 100vw;
  }

  @media (--from-desktop) {
    width: 940px;
    max-width: var(--fronton-layout-width);
  }

  @media (--from-largeDesktop) {
    width: 1180px;
  }
`;

export const pageContentStyles = css`
  display: inline-block;
  background-color: var(--background-secondary);
  border-radius: var(--rounding-l);
  padding: var(--space-200);
  max-width: 100%;

  @media (--to-tablet) {
    padding-right: 0;
  }

  @media (--to-desktop) {
    width: 100vw;
    border-radius: initial;
    padding: var(--space-200) 0;
    max-width: none;
  }
`;

export const topLineStyles = css`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  width: 100%;

  @media (--only-mobile) {
    margin-bottom: var(--space-200);
  }

  @media (--from-tablet) {
    margin-bottom: var(--space-125);
  }
`;
export const brandShelfTopLineStyles = css`
  width: 100%;
  margin-bottom: 0;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
`;

export const titleStyle = css`
  color: var(--text-primary);
  font-feature-settings:
    'clig' off,
    'liga' off;
  font-size: 20px !important;
  font-style: normal !important;
  font-weight: 500 !important;
  line-height: 26px !important;
  text-transform: uppercase !important;
`;

export const brandShelfTitleStyle = css`
  color: var(--text-primary);
  font-feature-settings:
    'liga' off,
    'clig' off;
  font-size: 21px !important;
  font-style: normal !important;
  font-weight: 600 !important;
  line-height: 26px !important;
  letter-spacing: 0.25px;
`;

export const brandShelfSubtitleStyle = css`
  color: var(--text-secondary);
  font-feature-settings:
    'liga' off,
    'clig' off;
  font-size: 15px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: 20px !important;
  letter-spacing: 0.2px;
  margin-bottom: 16px !important;
`;

export const brandShelfWrapper = css`
  gap: 20px;

  @media (--from-desktop) {
    padding-left: unset;
  }

  @media (--only-mobile) {
    gap: 16px;
  }

  @media (--only-tablet) {
    gap: 24px;
  }

  @media (--only-desktop) {
    gap: 38px;
  }
`;

export const carouselItemStyles = css`
  --item-width: 375px;

  position: relative;
  min-width: var(--item-width);
  width: var(--item-width);

  @media (--only-tablet) {
    --item-width: 144px;
  }

  @media (--only-mobile) {
    --item-width: 128px;
  }

  @media (--from-desktop) {
    --item-width: 375px;
  }
`;

export const carouselItemStylesSimplified = css`
  --item-width: 375px;

  position: relative;
  min-width: var(--item-width);
  width: var(--item-width);

  @media (--only-tablet) {
    --item-width: 144px;
  }

  @media (--only-mobile) {
    --item-width: 128px;
  }

  @media (--from-desktop) {
    --item-width: 280px;
  }
`;

export const seeMoreCarouselItem = css`
  margin-right: 0;
`;
